export const insightsPublicRoutesConstants = {
  root: {
    path: "/r/pc/insights",
    href: () => "/r/pc/insights"
  },
  roadmap: {
    path: "/r/pc/insights/roadmap/:token",
    href: (token: string) => `/r/pc/insights/roadmap/${token}`
  }
} as const;
